<template>
  <kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
      <div class="card" style="overflow:inherit">
        <div class="card-header bg-transparent" id="headingOne">
          <div class="card-title collapsed" data-toggle="collapse"
               data-target="#filterForm"
               aria-controls="filterForm">
            {{ $t('label.search') }}
          </div>
        </div>
        <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
          <div class="card-body">
            <form @submit.prevent="action($event, query)">
              <kt-form-section>
                <kt-form-row>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="hash_id">
                        {{ $t('online-factor.hash_id')}}
                      </kt-form-label>
                      <kt-form-control
                          ref="hash_id"
                          name="hash_id"
                          id="hash_id"
                          v-model="query.hash_id"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="name">
                        {{ $t('online-factor.name')}}
                      </kt-form-label>
                      <kt-form-control
                          ref="name"
                          name="name"
                          id="name"
                          v-model="query.name"/>
                    </kt-form-group>
                  </kt-col>
                  <kt-col v-if="$can('change-setting', 'payment-link')" xs="12" sm="6" md="4">
                    <kt-form-group>
                      <kt-form-label for="creator">
                        {{ $t('online-factor.creator')}}
                      </kt-form-label>
                      <kt-form-control
                          ref="creator"
                          name="creator"
                          id="creator"
                          v-model="query.creator"/>
                    </kt-form-group>
                  </kt-col>
                </kt-form-row>
              </kt-form-section>
              <kt-form-section>
                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
              </kt-form-section>
            </form>
          </div>
        </div>
      </div>
    </div>
  </kt-panel>
</template>

<script>
export default {
  name: "filter_format",
  props: {
    action: {
      default: function(e, query) {},
      required: true
    }
  },
  data() {
    return {
      query: {
      },

    }
  },
  methods: {

  },
}
</script>

<style scoped>

</style>